// extracted by mini-css-extract-plugin
export default {"text":"ChildrenModeJungleGreeting_text__r74Lr"};